import { Component, OnInit } from '@angular/core';
import { ChildQuery, ChildService } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { UpgradeChildrenComponent } from '../upgrade-children/upgrade-children.component';
import { OwlCarouselSettings } from 'src/app/shared/utilities/owl-carousel-settings';

@Component({
  selector: 'fgb-child-list',
  templateUrl: 'child-list.component.html',
  styleUrls: ['child-list.component.scss'],
})
export class ChildListComponent implements OnInit {
  children$: Observable<{ data: any[]; free: any[]; empty: any[]; limit: number }>;
  customOptions: OwlOptions = {
    margin: OwlCarouselSettings.Margin,
    autoWidth: true,
    pullDrag: false,
    nav: false,
    responsive: {
      0: { items: 1.2 },
      900: { items: 3 },
    },
    dots: true,
  };
  loaded$: Observable<boolean>;

  constructor(private childQuery: ChildQuery, private childService: ChildService, private modalService: NgbModal) {}

  ngOnInit() {
    this.childService.fetchChildCountLimit().toPromise();
    this.children$ = this.childQuery.getChildrenInfo();
    this.loaded$ = this.childQuery.isLoaded$;
  }

  upgradeChildren() {
    this.modalService.open(UpgradeChildrenComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'upgrade-children-modal',
      size: 'lg',
      centered: true,
    });
  }
}
